module.exports = __webpack_public_path__ + "static/media/5.e09a52f1.svg";